/* eslint-disable no-underscore-dangle */
import Track from 'core/logger/track';
import * as actions from '../types/names';

class CitationGeneratorTrack {
  private _countUserSearchedInCitationList = 0;
  // changedCitationSource = (triggeredBy: string, citationSourceName: string) => {
  //   Track.getInstance().ampEvent(actions.CHANGED_CITATION_SOURCE, {
  //     citationSourceName,
  //     triggeredBy,
  //   });
  //   Track.getInstance().storeActionEvent(actions.CHANGED_CITATION_SOURCE, {
  //     citationSourceName,
  //     triggeredBy,
  //   });
  // };

  userSearchedQuery = (citationSourceName: string, query: string) => {
    Track.getInstance().ampEvent(actions.USER_SEARCHED_QUERY, { citationSourceName });
    Track.getInstance().storeActionEvent(actions.USER_SEARCHED_QUERY, {
      citationSourceName,
      query,
    });
  };

  userClickedComposeCitation = () => {
    Track.getInstance().ampEvent(actions.USER_CLICKED_COMPOSE_NEW_CITATION);
    Track.getInstance().storeActionEvent(actions.USER_CLICKED_COMPOSE_NEW_CITATION);
  };

  userChangedCitationStyle = (citationStyleName: string, triggeredBy: string) => {
    Track.getInstance().ampEvent(actions.USER_CHANGED_CITATION_STYLE, {
      citationStyleName,
      triggeredBy,
    });
    Track.getInstance().storeActionEvent(actions.USER_CHANGED_CITATION_STYLE, {
      citationStyleName,
      triggeredBy,
    });
  };

  // userClickedBackButton = () => {
  //   Track.getInstance().ampEvent(actions.USER_CLICKED_BACK_BUTTON);
  //   Track.getInstance().storeActionEvent(actions.USER_CLICKED_BACK_BUTTON);
  // };

  // userClosedPreviewModal = () => {
  //   Track.getInstance().ampEvent(actions.USER_CLOSED_PREVIEW_MODAL);
  //   Track.getInstance().storeActionEvent(actions.USER_CLOSED_PREVIEW_MODAL);
  // };

  userClickedAddCitation = (triggeredBy: string) => {
    Track.getInstance().ampEvent(actions.USER_CLICKED_ADD_CITATION, { triggeredBy });
    Track.getInstance().storeActionEvent(actions.USER_CLICKED_ADD_CITATION, { triggeredBy });
  };

  userClickedDeleteCitation = (triggeredBy: string) => {
    Track.getInstance().ampEvent(actions.USER_CLICKED_DELETE_CITATION, { triggeredBy });
    Track.getInstance().storeActionEvent(actions.USER_CLICKED_DELETE_CITATION, { triggeredBy });
  };

  userClickedEditCitation = (triggeredBy: string) => {
    Track.getInstance().ampEvent(actions.USER_CLICKED_EDIT_CITATION, { triggeredBy });
    Track.getInstance().storeActionEvent(actions.USER_CLICKED_EDIT_CITATION, { triggeredBy });
  };

  // userClickedExportToDocButton = (citationStyleName: string, numberOfCitations: number) => {
  //   Track.getInstance().ampEvent(actions.USER_CLICKED_EXPORT_TO_DOC, {
  //     citationStyleName,
  //     numberOfCitations,
  //   });
  //   Track.getInstance().storeActionEvent(actions.USER_CLICKED_EXPORT_TO_DOC, {
  //     citationStyleName,
  //     numberOfCitations,
  //   });
  // };

  userClickedExportButton = (citationStyleName: string, triggeredBy: string) => {
    Track.getInstance().ampEvent(actions.USER_CLICKED_EXPORT_BUTTON, {
      citationStyleName,
      triggeredBy,
    });
    Track.getInstance().storeActionEvent(actions.USER_CLICKED_EXPORT_BUTTON, {
      citationStyleName,
      triggeredBy,
    });
  };

  userClickedCopyAllCitationsButton = (citationStyleName: string) => {
    Track.getInstance().ampEvent(actions.USER_CLICKED_COPY_ALL_FULL_TEXT_CITATIONS_BUTTON, {
      citationStyleName,
    });
    Track.getInstance().storeActionEvent(actions.USER_CLICKED_COPY_ALL_FULL_TEXT_CITATIONS_BUTTON, {
      citationStyleName,
    });
  };

  userClickedCopyInTextCitationButton = (citationStyleName: string, triggeredBy: string) => {
    Track.getInstance().ampEvent(actions.USER_CLICKED_COPY_SINGLE_IN_TEXT_CITATION_BUTTON, {
      citationStyleName,
      triggeredBy,
    });
    Track.getInstance().storeActionEvent(actions.USER_CLICKED_COPY_SINGLE_IN_TEXT_CITATION_BUTTON, {
      citationStyleName,
      triggeredBy,
    });
  };

  userClickedCopySingleFullTextCitationButton = (citationStyleName: string) => {
    Track.getInstance().ampEvent(actions.USER_CLICKED_COPY_SINGLE_FULL_TEXT_CITATION, {
      citationStyleName,
    });
    Track.getInstance().storeActionEvent(actions.USER_CLICKED_COPY_SINGLE_FULL_TEXT_CITATION, {
      citationStyleName,
    });
  };

  userClickedCloneCitation = () => {
    Track.getInstance().ampEvent(actions.USER_CLICKED_CLONE_CITATION);
    Track.getInstance().storeActionEvent(actions.USER_CLICKED_CLONE_CITATION);
  };

  userClickedOpenSource = () => {
    Track.getInstance().ampEvent(actions.USER_CLICKED_OPEN_SOURCE);
    Track.getInstance().storeActionEvent(actions.USER_CLICKED_OPEN_SOURCE);
  };

  userClickedMissingInfoBanner = (action: 'edit' | 'close') => {
    let actionName = `${actions.USER_CLICKED_EDIT_CITATION}/missing_info_chip`;
    if (action === 'close') {
      actionName = actions.IgnoreWarning;
    }
    Track.getInstance().ampEvent(actionName);
    Track.getInstance().storeActionEvent(actionName, {
      action,
      source: action === 'edit' ? 'missing_info_chip' : undefined,
    });
  };

  userSearchedInCitationList = () => {
    if (this._countUserSearchedInCitationList === 0) {
      Track.getInstance().ampEvent(actions.USER_SEARCHED_IN_CITATION_LIST);
      this._countUserSearchedInCitationList += 1;
    }
  };
}

const citationGeneratorTrack = new CitationGeneratorTrack();
export default citationGeneratorTrack;
